import React, { useState, useEffect, useMemo } from "react";
import "./WelcomeModal.css";
import modal_logo from "../../../../_assets/img/modal_logo.png";

import { useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Card } from "primereact/card";


const FEATURES = [
  {
    key: "AreaMeasurer",
    title: "Medidor de Área",
    desc: "Desenhe polígonos e meça áreas (m²/ha/km²). Permite copiar o resultado.",
    icon: "pi-expand",
  },
  {
    key: "BaseLayer",
    title: "Mapa Base",
    desc: "Troque entre satélite, rua, terreno etc. Ajuste a opacidade do fundo.",
    icon: "pi-images",
  },
  {
    key: "DistanceMeasurer",
    title: "Medidor de Distância",
    desc: "Meça distâncias com linhas/polilinhas e acumulado por segmento.",
    icon: "pi-arrows-h",
  },
  {
    key: "FeatureInfo",
    title: "Informação da Feição",
    desc: "Clique no mapa para ver atributos da feição. Abre tabela/links quando houver.",
    icon: "pi-info-circle",
  },
  {
    key: "FileUploader",
    title: "Importar Arquivos",
    desc: "Carregue GeoJSON, Shapefile (zip), KML ou CSV e visualize no mapa.",
    icon: "pi-cloud-upload",
  },
  {
    key: "GovFooterBar",
    title: "Rodapé Institucional",
    desc: "Créditos, contato, termos e links úteis do projeto.",
    icon: "pi-align-justify",
  },
  {
    key: "GovHeaderBar",
    title: "Cabeçalho",
    desc: "Logomarcas, navegação e atalhos principais da plataforma.",
    icon: "pi-bars",
  },
  {
    key: "GridLayer",
    title: "Grade Cartográfica",
    desc: "Exibe grade (UTM/Latitude-Longitude) configurável sobre o mapa.",
    icon: "pi-th-large",
  },
  {
    key: "HintWindow",
    title: "Dicas em Contexto",
    desc: "Mensagens curtas que explicam a ferramenta ativa e como usá-la.",
    icon: "pi-comment",
  },
  {
    key: "HorizontalToolbarToggler",
    title: "Mostrar/Ocultar Ferramentas",
    desc: "Alterna a barra de ferramentas horizontal para ganhar espaço.",
    icon: "pi-sliders-h",
  },
  {
    key: "LayerSwitcher",
    title: "Gerenciador de Camadas",
    desc: "Liga/desliga camadas, organiza grupos, reordena e ajusta opacidade.",
    icon: "pi-clone",
  },
  {
    key: "LegendPopup",
    title: "Legenda Rápida",
    desc: "Mostra a legenda da camada ativa conforme o estilo do GeoServer.",
    icon: "pi-tags",
  },
  {
    key: "LocateAddress",
    title: "Buscar Endereço",
    desc: "Geocodifique endereços/lugares e faça zoom para a localização.",
    icon: "pi-search",
  },
  {
    key: "LocateMe",
    title: "Minha Localização",
    desc: "Centraliza no GPS do navegador e pode acompanhar movimento.",
    icon: "pi-compass",
  },
  {
    key: "MapWrapper",
    title: "Container do Mapa",
    desc: "Orquestração do mapa e eventos (infraestrutura do módulo).",
    icon: "pi-map",
  },
  {
    key: "MouseWatcher",
    title: "Coordenadas do Mouse",
    desc: "Exibe latitude/longitude (ou UTM) e escala sob o cursor.",
    icon: "pi-directions-alt",
  },
  {
    key: "Navbar",
    title: "Navegação",
    desc: "Menu principal entre módulos e páginas da plataforma.",
    icon: "pi-list",
  },
  {
    key: "PngExporter",
    title: "Exportar PNG",
    desc: "Gera imagem do mapa com título, escala e data (quando configurado).",
    icon: "pi-image",
  },
  {
    key: "ResetRotation",
    title: "Resetar Rotação",
    desc: "Restaura a orientação do mapa para 0°.",
    icon: "pi-refresh",
  },
  {
    key: "ResetZoom",
    title: "Enquadramento Padrão",
    desc: "Volta para a extensão inicial do projeto.",
    icon: "pi-search-minus",
  },
  {
    key: "ScaleBar",
    title: "Barra de Escala",
    desc: "Escala gráfica dinâmica de acordo com o nível de zoom.",
    icon: "pi-sort-alt",
  },
  {
    key: "StatisticGraphics",
    title: "Gráficos Estatísticos",
    desc: "Gera gráficos (barras/pizza/linhas) a partir de seleção ou camada.",
    icon: "pi-chart-bar",
  },
  {
    key: "StoryTelling",
    title: "Storytelling",
    desc: "Narrativas guiadas com páginas, mapas, texto, imagens e gráficos.",
    icon: "pi-book",
  },
  {
    key: "LayerFilter",
    title: "Filtro de Camada (CQL)",
    desc: "Filtre por atributos/expressões CQL. Salve e reutilize filtros.",
    icon: "pi-filter",
  },
  {
    key: "LayerScope",
    title: "Escopo da Camada",
    desc: "Define recortes/zoom para a camada ativa (limites e foco).",
    icon: "pi-map-marker",
  },
  {
    key: "LegendGraphic",
    title: "Legenda Gráfica (GeoServer)",
    desc: "Baixa/exibe a legenda gerada pelo SLD do GeoServer (raster/SVG).",
    icon: "pi-tag",
  },
];

const TABS = [
  { key: "inicio", label: "Início", icon: "pi-file-check" },
  { key: "funcionalidades", label: "Ferramentas", icon: "pi-wrench" },
  { key: "outras", label: "Outras funcionalidades", icon: "pi-th-large" },
];

const WelcomeModal = ({ active, callback }) => {
  const { t } = useTranslation();
  const clientWidth = document.documentElement.clientWidth;

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [agreeTerms, setAgreeTerms] = useState(false);
  const [agreePrivacy, setAgreePrivacy] = useState(false);

  const [tab, setTab] = useState("inicio");
  const canFinish = agreeTerms && agreePrivacy;
  const tabIndex = useMemo(() => TABS.findIndex((tItem) => tItem.key === tab), [tab]);
  const isFirst = tabIndex === 0;
  const isLast = tabIndex === TABS.length - 1;

  const goNext = () => !isLast && setTab(TABS[tabIndex + 1].key);
  const goPrev = () => !isFirst && setTab(TABS[tabIndex - 1].key);

  useEffect(() => {
    if (active) handleShow();
  }, [active]);

  useEffect(() => {
    callback(show);
  }, [show]);

  useEffect(() => {
    if (
      sessionStorage.getItem("FirstAccess") === undefined ||
      sessionStorage.getItem("FirstAccess") === null
    ) {
      sessionStorage.setItem("FirstAccess", true);
    }

    if (sessionStorage.getItem("FirstAccess") === "true") {
      handleShow();
      sessionStorage.setItem("FirstAccess", false);
    }
  }, []);

  const headerContent = (
    <div className="WmHeader">
      <div className="ContainerLogo">
        <img
          className="ModalLogo"
          alt="Logo"
          title="Logo"
          src={ modal_logo}
        />
      </div>

      <div className="WmTabs" role="tablist">
        {TABS.map((tItem) => (
          <button
            key={tItem.key}
            type="button"
            role="tab"
            aria-selected={tab === tItem.key}
            className={`WmTab ${tab === tItem.key ? "WmTab--active" : ""}`}
            onClick={() => setTab(tItem.key)}
          >
            <i className={`pi ${tItem.icon}`} />
            <span>{tItem.label}</span>
          </button>
        ))}
      </div>
    </div>
  );

  const footerContent = (
    <div className="WmFooter">
      <div className="WmStep">
        <span className="WmStepDot" />
        Passo {tabIndex + 1} de {TABS.length}
      </div>
      <div className="containerBtns">
        {tab === "inicio" && (
          <Button
            onClick={handleClose}
            disabled={!canFinish}
            className="WmBtn WmBtn--primary"
            label="Concordo e continuar"
            icon="pi pi-check"
          />
        )}
        <Button
          onClick={goPrev}
          disabled={isFirst}
          className="WmBtn WmBtn--ghost"
          label="Voltar"
          icon="pi pi-arrow-left"
        />
        {!isLast && (
          <Button
            onClick={goNext}
            disabled={tab === "inicio" && !canFinish}
            className="WmBtn WmBtn--accent"
            label="Próximo"
            icon="pi pi-arrow-right"
            iconPos="right"
          />
        )}
      </div>
    </div>
  );

  return (
    <Dialog
      className="WelcomeModal"
      visible={show}
      onHide={handleClose}
      closable={false}
      closeOnEscape={false}
      dismissableMask={false}
      draggable={false}
      resizable={false}
      modal
      header={headerContent}
      footer={footerContent}
      breakpoints={{ "1000px": "95vw", "700px": "100vw" }}
      style={{ width: "1100px", maxWidth: "95vw" }}
    >
      <div className="ModalBodyContent">
        {tab === "inicio" && (
          <section>
            <h4 className="WmHeading">{t("welcomeModal.title")}</h4>
            <p className="ModalText">{t("welcomeModal.section1.0")}</p>
            <p className="ModalText">{t("welcomeModal.section1.1")}</p>

            <h4 className="WmHeading">{t("welcomeModal.termsTitle")}</h4>
            <p className="ModalText">{t("welcomeModal.section2.0")}</p>
            <p className="ModalText">{t("welcomeModal.section2.1")}</p>

            <a
              className="TermLink"
              href="/portal/termos_e_condicoes_de_uso_pedea.pdf"
              target="_blank"
              rel="noreferrer"
            >
              {t("welcomeModal.readTerms")}
            </a>

            <h4 className="WmHeading">{t("welcomeModal.privacyTitle")}</h4>
            <p className="ModalText">{t("welcomeModal.section3.0")}</p>
            <p className="ModalText">{t("welcomeModal.section3.1")}</p>

            <a
              className="TermLink"
              href="/portal/aviso_privacidade_pedea.pdf"
              target="_blank"
              rel="noreferrer"
            >
              {t("welcomeModal.readPrivacy")}
            </a>

            <div className="WelcomeModalFooter">
              <div className="TermCheckBox">
                <Checkbox
                  inputId="checkTermAndConditions"
                  checked={agreeTerms}
                  onChange={(e) => setAgreeTerms(e.checked)}
                />
                <label htmlFor="checkTermAndConditions">
                  {t("welcomeModal.checkboxTerms")}
                </label>
              </div>
              <div className="TermCheckBox">
                <Checkbox
                  inputId="checkLegalWarning"
                  checked={agreePrivacy}
                  onChange={(e) => setAgreePrivacy(e.checked)}
                />
                <label htmlFor="checkLegalWarning">
                  {t("welcomeModal.checkboxPrivacy")}
                </label>
              </div>
            </div>
          </section>
        )}

        {tab === "funcionalidades" && (
          <section>
            <h4 className="WmHeading">Ferramentas</h4>
            <div className="GridFerramentas">
              {FEATURES.map((f) => (
                <Card key={f.key} className="CardFerramentas">
                  <div className="CardFerramentasBadge">
                    <i className={`pi ${f.icon}`} />
                  </div>
                  <h6 className="CardTitle">{f.title}</h6>
                  <p className="CardText">{f.desc}</p>
                </Card>
              ))}
            </div>
          </section>
        )}

        {tab === "outras" && (
          <section>
            <h4 className="WmHeading">Outras Funcionalidades</h4>
            <div className="ContainerOutrasFuncionalidades">
              <Card className="containersInfos">
                <div className="CardFerramentasBadge CardFerramentasBadge--outline">
                  <i className="pi pi-question-circle" />
                </div>
                <h6 className="CardTitle">FAQ</h6>
                <p className="CardTextMuted">
                  Dúvidas frequentes sobre uso e dados.
                </p>
                <Button
                  onClick={() => window.open("/portal/faq.html", "_blank")}
                  label="Abrir FAQ"
                  icon="pi pi-arrow-right"
                  iconPos="right"
                  className="WmBtn WmBtn--link"
                />
              </Card>
              <Card className="containersInfos">
                <div className="CardFerramentasBadge CardFerramentasBadge--outline">
                  <i className="pi pi-history" />
                </div>
                <h6 className="CardTitle">Histórico evolutivo</h6>
                <p className="CardTextMuted">
                  Versões, melhorias e correções.
                </p>
                <Button
                  onClick={() =>
                    window.open("/portal/versioning.html", "_blank")
                  }
                  label="Ver histórico"
                  icon="pi pi-arrow-right"
                  iconPos="right"
                  className="WmBtn WmBtn--link"
                />
              </Card>
              <Card className="containersInfos">
                <div className="CardFerramentasBadge CardFerramentasBadge--outline">
                  <i className="pi pi-database" />
                </div>
                <h6 className="CardTitle">Portal de Dados</h6>
                <p className="CardTextMuted">
                  Metadados, mapas e site administrativo.
                </p>
                <Button
                  onClick={() =>
                    window.open("https://hgpedea.sema.ce.gov.br/gestor", "_blank")
                  }
                  label="Guia de acesso"
                  icon="pi pi-arrow-right"
                  iconPos="right"
                  className="WmBtn WmBtn--link"
                />
              </Card>
              <Card className="containersInfos">
                <div className="CardFerramentasBadge CardFerramentasBadge--outline">
                  <i className="pi pi-server" />
                </div>
                <h6 className="CardTitle">Acesso & Download (GeoServer)</h6>
                <p className="CardTextMuted">
                  WMS/WFS/WCS, CQL e exemplos de requisição.
                </p>
                <Button
                  onClick={() =>
                    window.open("https://hgpedea.sema.ce.gov.br/geoserver", "_blank")
                  }
                  label="Guia de acesso"
                  icon="pi pi-arrow-right"
                  iconPos="right"
                  className="WmBtn WmBtn--link"
                />
              </Card>
            </div>
          </section>
        )}
      </div>
    </Dialog>
  );
};

export default WelcomeModal;